import type { HttpStatusCode } from 'axios'
import { defineStore, acceptHMRUpdate } from 'pinia'
import { computed, ref } from 'vue'
import storeConfigs from 'constants/storeConfigs.ts'

type Status = 'initial' | 'error' | 'success' | 'pending' | null
type Data = {} | undefined
type ErrorInfo =
	| {
			data: any
			endpoint: string
			error: any
			headers: any
			message: string
			result: boolean
			status: HttpStatusCode
			statusText: string
	  }
	| undefined

export const useAlertStore = defineStore(storeConfigs.alert.name, () => {
	const status = ref<Status>('initial')
	const data = ref<Data>(undefined)
	const failure = ref<ErrorInfo>(undefined)

	const isError = computed<Data>(() => status.value === 'error')

	function successAlert(value: any) {
		status.value = 'success'
		data.value = value
		failure.value = undefined
	}

	function errorAlert(value: ErrorInfo) {
		status.value = 'error'
		data.value = undefined
		failure.value = value
	}

	function pendingAlert() {
		status.value = 'pending'
		data.value = {}
		failure.value = undefined
	}

	function clearAlert() {
		status.value = null
		data.value = {}
		failure.value = undefined
	}

	function $reset() {
		status.value = 'initial'
		data.value = undefined
		failure.value = undefined
	}

	return {
		status,
		failure,
		isError,
		successAlert,
		errorAlert,
		pendingAlert,
		clearAlert,
		$reset,
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useAlertStore, import.meta.hot))
}
